import { alpha, createTheme } from "@mui/material/styles";


export const MAIN_COLOR = '#775EAC'
export const MAIN_COLOR_ACTIVE = '#DC88D4'
export const SECONDARY_COLOR = '#ACA45E';
export const WARN_COLOR = '#DE762B';
export const ERROR_COLOR = '#AE1B43';
export const INFO_COLOR = '#22DDFF';

export const WHITE = "#fff"
export const BLACK = "#000"
export const GREY = {
    '100': '#1E1E1E',
    '200': '#29272E',
    '300': '#4C4559',
    '400': '#535157',
    '500': '#69676d',
    '600': '#807f84',
    '700': '#9D96AE',
    '800': '#b1b0b3',
    '900': '#cacacc',
}

export const MAIN_FONT = [
    'Inter', 'sans-serif',
].join(',')



export const MAIN_THEME = createTheme({
    spacing: 4,

    shape: {
        borderRadius: 3,    // defaults to 4
    },

    palette: {
        background: {
            default: GREY[200]
        },
        text: {
            primary: WHITE,
            secondary: '#9D96AE',
        },
        primary: {
            main: MAIN_COLOR,
            contrastText: WHITE,
        },
        secondary: {
            main: SECONDARY_COLOR,
            contrastText: WHITE,
        },
        warning: {
            main: WARN_COLOR,
        },
        error: {
            main: ERROR_COLOR,
        },
        mode: 'dark',

    },


    typography: {

        fontSize: 14,
        htmlFontSize: 18,

        button: {
            fontWeight: '600',
            fontSize: 14,
            fontFamily: MAIN_FONT,
        },

        fontFamily: MAIN_FONT,
    },


    components: {
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minWidth: 0,
                }
            }
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    padding: 2,
                },
            },

            defaultProps: {
                disableElevation: true,
            },
        },

        MuiListItemButton: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        backgroundColor: '#E79E8E',
                        borderColor: '#9C553E',
                        ".MuiListItemText-root .MuiListItemText-secondary.MuiTypography-root, .secondary-text": {
                            color: '#000',
                        },
                        "&:hover": {
                            backgroundColor: '#E79E8E',
                        }
                    }
                }
            }
        },
    }
})